import { HttpInterceptorFn } from '@angular/common/http';
import { resolveSiteHeaderValue } from '../../shared/utils/portal-hosts';

const SITE_HEADER_NAME = 'site';

export const siteHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach the `site` header for calls targeting our own backend.
  // Sending it on cross-origin requests (e.g. WordPress at qne.cloud) makes
  // the browser issue a CORS preflight asking for the `site` header, which
  // those servers don't allow → request fails with net::ERR_FAILED.
  const isApiCall = req.url.includes('api/');
  if (!isApiCall) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        // Hostname-based so shared slots (account-test + n3-test) send the right site.
        [SITE_HEADER_NAME]: resolveSiteHeaderValue()
      }
    })
  );
};
